import { DefaultQueryParams, parseQuery } from '@pascal/pascal-core';
import { action, makeObservable, observable } from 'mobx';

class GameStore {
  isBetsClosed = false;

  isNotification = false;

  gameTypeId = null;

  isSplitCardAnimationByBox = 0;

  isInsurance = null;

  isInsuranceLose = false;

  notificationText = '';

  isShowDecision = false;

  activeBox = null;

  activeHandByBox = null;

  activeAnimationBox = null;

  activeBetId = null;

  possibleActions = [];

  isSelectedDecision = false;

  isHandleInitialStateEnded = false;

  isInsuranceDecisionOpened = false;

  dealerInsuranceAnimationStart = false;

  decisionDuration = null;

  constructor() {
    makeObservable(this, {
      activeBox: observable,
      gameTypeId: observable,
      activeBetId: observable,
      isInsurance: observable,
      isBetsClosed: observable,
      isShowDecision: observable,
      isNotification: observable,
      possibleActions: observable,
      activeHandByBox: observable,
      isInsuranceLose: observable,
      notificationText: observable,
      decisionDuration: observable,
      activeAnimationBox: observable,
      isSelectedDecision: observable,
      isInsuranceDecisionOpened: observable,
      isHandleInitialStateEnded: observable,
      isSplitCardAnimationByBox: observable,
      dealerInsuranceAnimationStart: observable,
      setActiveBox: action.bound,
      setGameTypeId: action.bound,
      setActiveBetId: action.bound,
      setIsInsurance: action.bound,
      setIsBetsClosed: action.bound,
      setIsNotification: action.bound,
      setActiveHandByBox: action.bound,
      setPossibleActions: action.bound,
      setIsInsuranceLose: action.bound,
      setDecisionDuration: action.bound,
      setNotificationText: action.bound,
      updateIsShowDecision: action.bound,
      setActiveAnimationBox: action.bound,
      setIsSplitCardAnimationByBox: action.bound,
      setIsSelectedDecision: action.bound,
      setDealerInsuranceAnimationStart: action.bound,
      setIsInsuranceDecisionOpened: action.bound,
    });
  }

  setIsInsuranceLose(bool) {
    this.isInsuranceLose = bool;
  }

  setDealerInsuranceAnimationStart(bool) {
    this.dealerInsuranceAnimationStart = bool;
  }

  setIsSplitCardAnimationByBox(bool) {
    this.isSplitCardAnimationByBox = bool;
  }

  setIsInsurance(bool) {
    this.isInsurance = bool;
  }

  setDecisionDuration(second) {
    this.decisionDuration = second;
  }

  setIsHandleInitialStateEnded(bool) {
    this.isHandleInitialStateEnded = bool;
  }

  setIsSelectedDecision(bool) {
    this.isSelectedDecision = bool;
  }

  setIsBetsClosed(arg) {
    this.isBetsClosed = arg;
  }

  setActiveBetId(id) {
    this.activeBetId = id;
  }

  updateIsShowDecision(bool) {
    this.isShowDecision = bool;
  }

  setActiveBox(boxIndex) {
    this.activeBox = boxIndex;
  }

  setActiveHandByBox(activeHandByBox) {
    this.activeHandByBox = activeHandByBox;
  }

  setActiveAnimationBox(activeAnimationBox) {
    this.activeAnimationBox = activeAnimationBox;
  }

  setPossibleActions(possibleActions) {
    this.possibleActions = possibleActions;
  }

  setGameTypeId() {
    const { [DefaultQueryParams.GameTypeId]: gameTypeId } = parseQuery(window.location.search);
    this.gameTypeId = gameTypeId;
  }

  setNotificationText(text) {
    this.notificationText = text;
  }

  setIsNotification(bool) {
    this.isNotification = bool;
  }

  setIsInsuranceDecisionOpened(bool) {
    this.isInsuranceDecisionOpened = bool;
  }
}

export const gameStore = new GameStore();
